__turbopack_context__.v({
  "codeBlock": "markdown-response-module__QY3Isa__codeBlock",
  "markdown": "markdown-response-module__QY3Isa__markdown",
  "tableScroll": "markdown-response-module__QY3Isa__tableScroll",
});
